"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GracefulProvider = exports.userExponentialBackOffFn = exports.maxRequestResolveTime = exports.maxBackOffTime = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var hooks_1 = require("../hooks");
var react_1 = require("react");
var graceful_context_1 = require("./graceful-context");
exports.maxBackOffTime = 20;
exports.maxRequestResolveTime = 10;
exports.userExponentialBackOffFn = undefined;
var GracefulProvider = function (_a) {
    var children = _a.children, config = _a.config;
    var _b = (0, react_1.useState)(graceful_context_1.initialProps), props = _b[0], setGraceful = _b[1];
    (0, hooks_1.useInterceptors)(setGraceful, config);
    (0, react_1.useEffect)(function () {
        exports.maxBackOffTime = (config === null || config === void 0 ? void 0 : config.maxBackOffTime) || 20;
    }, [config === null || config === void 0 ? void 0 : config.maxBackOffTime]);
    (0, react_1.useEffect)(function () {
        exports.maxRequestResolveTime = (config === null || config === void 0 ? void 0 : config.maxRequestResolveTime) || 10;
    }, [config === null || config === void 0 ? void 0 : config.maxRequestResolveTime]);
    (0, react_1.useEffect)(function () {
        exports.userExponentialBackOffFn = config === null || config === void 0 ? void 0 : config.exponentialBackOffFn;
    }, [config === null || config === void 0 ? void 0 : config.exponentialBackOffFn]);
    var value = (0, react_1.useMemo)(function () { return (__assign(__assign(__assign(__assign(__assign(__assign({}, props), ((config === null || config === void 0 ? void 0 : config.theme) && { theme: config.theme })), ((config === null || config === void 0 ? void 0 : config.errorComponentMap) && {
        errorComponentMap: config.errorComponentMap,
    })), ((config === null || config === void 0 ? void 0 : config.DefaultErrorComponent) && {
        DefaultErrorComponent: config.DefaultErrorComponent,
    })), ((config === null || config === void 0 ? void 0 : config.WaitingRoomErrorComponent) && {
        WaitingRoomErrorComponent: config.WaitingRoomErrorComponent,
    })), { axios: config === null || config === void 0 ? void 0 : config.axios, setGraceful: setGraceful })); }, [config, props]);
    return ((0, jsx_runtime_1.jsx)(graceful_context_1.GracefulStore.Provider, __assign({ value: value }, { children: children })));
};
exports.GracefulProvider = GracefulProvider;
